import {  Text, Tab, TabGroup, Divider } from '@nike/eds';
import type { Exception, AuditTrailEntry, Comment, StatusChangeEvent } from '../../shared/Types';
import './exception-detail.css';
import { formatExceptionDate } from '../exceptions-table/ExceptionTableColumns';
import { useState } from 'react';

// Helper functions to filter entries
function getComments(entries: AuditTrailEntry[]): Comment[] {
  return entries.filter((e): e is Comment => e.__typename === 'Comment');
}
function getStatusChangeEvents(entries: AuditTrailEntry[]): StatusChangeEvent[] {
  return entries.filter((e): e is StatusChangeEvent => e.__typename === 'StatusChangeEvent');
}

const ExceptionAuditTrailItems = ({ statusChanges }: { statusChanges: StatusChangeEvent[] }) => {
  return (
    <div className='exception-audit-trail-items'>
      <ul>
        {statusChanges.map((item) => (
          <li key={item.id} >
            <Text font="body-2" className="eds-spacing--pt-8 eds-spacing--pr-16 eds-spacing--pb-8 eds-spacing--pl-4">
              <b>{item.user.name}</b> changed status from <b>{item.fromStatus ?? 'N/A'}</b> to <b>{item.toStatus}</b> on {formatExceptionDate(item.timestamp)}
            </Text>
            <Divider className="" />
          </li>
        ))}
      </ul>
    </div>
  );
};

const ExceptionCommentsSection = ({ comments }: { comments: Comment[] }) => {
  return (
    <div className='exception-comments-section'>
      <ul>
        {comments.map((comment) => (
          <li key={comment.id} >
            <Text font="body-2" className="eds-spacing--pt-8 eds-spacing--pr-16 eds-spacing--pb-8 eds-spacing--pl-4">
              <b>{comment.author.name}</b> commented on {formatExceptionDate(comment.timestamp)}:<br />
              {comment.content}
            </Text>
            <Divider />
          </li>
        ))}
      </ul>
    </div>
  );
};

export const AuditComments = ({ exception }: { exception: Exception }) => {
  const [activeTab, setActiveTab] = useState("audit");
  const auditTrailItems = exception.auditTrail?.items || [];
  const commentEntries = getComments(auditTrailItems);
  const statusChangeEntries = getStatusChangeEvents(auditTrailItems);

  return (
    <>  
      <TabGroup
        name="exception-tabs-group"
        variant='toggle-medium'
        activeId={activeTab}
        onChange={e => setActiveTab(e.target.id)}
      >
        <Tab id="audit">Additional Info ({statusChangeEntries.length})</Tab>
        <Tab id="comments">Comments ({commentEntries.length})</Tab>
      </TabGroup>

      <div>
        {activeTab === "audit" && (
          <ExceptionAuditTrailItems statusChanges={statusChangeEntries} />
        )}
        {activeTab === "comments" && (
          <ExceptionCommentsSection comments={commentEntries} />
        )}
      </div>
    </>
  );
};